import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Header from './cmp/header';
import Footer from './cmp/footer';
import CategoryPage from './cmp/category';
import ProductWrapper from './cmp/product-wrapper';
import SearchResults from "./cmp/SearchResults";
import Home from './cmp/home';
import GlobalStyles from './cmp/styles/GlobalSytes';
// import Login from './cmp/login';
// import Signup from './cmp/signup';
// import ForgotPassword from './cmp/forgot_password';
import ContactUs from './cmp/contact-us';
import Terms from './cmp/terms';
import Privacy from './cmp/privacy';
import ContactForm from './cmp/contact-form';
import AboutUs from './cmp/about-us';
import Education from './cmp/education';
import EducationArticle from './cmp/education-article';
import Videos from './cmp/videos';
import MindArticles from './cmp/mind-articles';
import MindArticle from './cmp/mind-article';
import Recipes from './cmp/recipes';
import RecipeDetail from './cmp/recipe-detail';
import MedicalTidbits from './cmp/medical-tidbits';

import PlayVideo from './cmp/play-video';
import Eat4living from './cmp/eat4living';
import Affiliates from './cmp/affiliates';

import AdminApp from './cmp/admin/App';

import RootStore from './cmp/redux/RootStore';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import db from "./cmp/firebase/firebase";

const HomeContainer = () => {
  const [contactInfo, setContactInfo] = useState({});
  const location = useLocation();
  const background = location.state && location.state.background;

  useEffect(() => {
    loadInfo()
  }, [])

  const loadInfo = async () => {
    let doc = await db.collection('contact-info')
      .doc('contact-info')
      .get()
    let data = doc.data()
    setContactInfo(data)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <div style={{ width: '100%' }}>
        <GlobalStyles />
        <Header contactInfo={contactInfo} />
        <div style={{ marginTop: 0 }}>
          <Routes location={background || location}>
            <Route path="/" element={<Home contactInfo={contactInfo} />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/product/:id" element={<ProductWrapper />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact-form" element={<ContactForm />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/education" element={<Education />} />
            <Route path="/education-article" element={<EducationArticle />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/play-video" element={<PlayVideo />} />
            <Route path="/eat4living" element={<Eat4living />} />
            <Route path="/mind-articles" element={<MindArticles />} />
            <Route path="/mind-article" element={<MindArticle />} />
            <Route path="/recipes" element={<Recipes />} />
            <Route path="/recipe-detail" element={<RecipeDetail />} />
            <Route path="/medical-tidbits" element={<MedicalTidbits />} />
            <Route path="/affiliates" element={<Affiliates />} />
          </Routes>

          {/* Modal Route Overlay */}
          {background && (
            <Routes>
              <Route path="/play-video" element={<PlayVideo />} />
            </Routes>
          )}
        </div>
        <Footer contactInfo={contactInfo} />
      </div>
    </div>
  )
}

class App extends React.Component {
  componentDidMount = () => {
    console.log('MOUNT')
  }

  render() {
    return (
      <Provider store={RootStore}>
        <Router>
          <Routes>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/*" element={<HomeContainer />} />
          </Routes>
          <ToastContainer />
        </Router>
      </Provider>
    );
  }
}

export default App;
